import { updateDocument } from '@lifetools/shared-database';

async function updateRemoteDocument(collection, id, updates) {
  const sentUpdates = await updateDocument(collection, id, updates);

  return Object.assign({}, sentUpdates, { id });
}

export default updateRemoteDocument;
